import RaycastVehicleImage from "../assets/ProjectImages/RaycastVehicle.png";
import LotteryImage from "../assets/ProjectImages/3DLottery.png";
import GodotNavigationImage from "../assets/ProjectImages/GodotNavigation.png";
import GodotTruckTownImage from "../assets/ProjectImages/GodotTruckTown.png";
import HexGridImage from "../assets/ProjectImages/HexGrid.png";

export interface LabItem {
  id: number;
  title: string;
  url: string;
  image?: string;
  description: string;
}

export const LabList: LabItem[] = [
  {
    id: 0,
    title: "Raycast Vehicle Physics",
    url: "https://raycast-vehicle-physics.vercel.app/",
    image: RaycastVehicleImage,
    description: "Three.js raycast-based vehicle physics demo.",
  },
  {
    id: 1,
    title: "3D Lottery",
    url: "https://3d-lottery-v1.vercel.app/",
    image: LotteryImage,
    description: "Interactive 3D lottery ball simulation.",
  },
  {
    id: 2,
    title: "Godot Navigation",
    url: "https://github.com/steller102/godot-navigation-demo",
    image: GodotNavigationImage,
    description: "Godot 3D navigation and pathfinding demo.",
  },
  {
    id: 3,
    title: "Godot Truck Town",
    url: "https://github.com/steller102/godot-truck-town",
    image: GodotTruckTownImage,
    description: "Godot vehicle driving demo in a 3D town.",
  },
  {
    id: 4,
    title: "Hex Grid Generator",
    url: "https://github.com/steller102/hex-grid-generator",
    image: HexGridImage,
    description: "Unity hexagonal grid generation system.",
  },
  {
    id: 5,
    title: "Character Controller",
    url: "https://github.com/steller102/character-controller",
    description: "Third-person character controller implementation.",
  },
  {
    id: 6,
    title: "Vehicle Physics System",
    url: "https://github.com/steller102/vehicle-physics-system",
    description: "Realistic vehicle physics with suspension and steering.",
  },
];
